import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CutsceneTemplat from '../Components/Layout/CutsceneTemplate';

import Commander from '../Assets/Imgs/Commander.png';
import Mike from '../Assets/Imgs/Mike.png';
import Btn from '../Components/Common/Btn';

import Pause from '../Assets/Icons/Pause.svg'
import PauseMenu from '../Components/Layout/PauseMenu';

const ShipCutscene = () => {

    const [currentLine, setCurrentLine] = useState(0)
    const [isPaused, setIsPaused] = useState(false);

    const navigate = useNavigate();

    const dialogue = [
            {
                img: Commander, text: `We've established connection with the station!`, DName: 'Commander'
            },

            {
                img: Commander, text: `However, I've just got word that you're heading into an astroid field.`, DName: 'Commander'
            },

            {
                img: Commander, text: `There should be a few ships docked in the stations hangar bay. Get one and get out of there, I'll take care of the station.`, DName: 'Commander'
            },
    
            {
                img: Mike, text: 'Got it! On my way.', DName: 'Private Mike'
            }
        ]

    const handleNextDialogue = () => {
        if (currentLine < dialogue.length - 1) {
            setCurrentLine(prevStep => prevStep + 1);
        } else {
            navigate('/L4');
        }
    };

    const currentDialogue = dialogue[currentLine];
    console.log(dialogue[0])

    return ( 
        <main className='FixedCutsceneMain'>

            <Btn BtnIcon={Pause} BtnStyle="PauseBtn" onClick={() => setIsPaused(true)}/>
            
            <CutsceneTemplat TemplateClass='ShipTemplate' DialogueImg={currentDialogue.img} DialogueName={currentDialogue.DName} DialogueP={currentDialogue.text} NextBtnChange={handleNextDialogue}/>

            {isPaused && <PauseMenu ResumeClick={()=>setIsPaused(false)}/>}
        </main>
     );
}
 
export default ShipCutscene;